import React from 'react';
import { FadeIn, Section } from './Section';
import { PricingSelector } from './PricingSelector';
import { UrgencyBanner } from './UrgencyBanner';
export function FinalCTA() {
  return <Section bg="plum" className="text-center py-10 md:py-24" data-id="element-76">
      <FadeIn className="max-w-5xl mx-auto" data-id="element-77">
        <h2 className="text-[10px] md:text-sm font-bold tracking-[0.2em] uppercase text-gold mb-4 md:mb-6" data-id="element-78">
          No dejes pasar esta oportunidad
        </h2>
        <p className="font-serif text-2xl md:text-4xl text-cream mb-6 md:mb-10 px-2 leading-tight" data-id="element-79">
          Tu próxima versión te está esperando del otro lado de esta decisión.
        </p>

        <UrgencyBanner data-id="element-80" />

        <div className="bg-cream/[0.04] backdrop-blur-sm border border-cream/10 rounded-lg p-4 md:p-8" data-id="element-81">
          <PricingSelector variant="compact" idPrefix="final-" data-id="element-82" />
        </div>
      </FadeIn>
    </Section>;
}